import { useState, type CSSProperties, type ImgHTMLAttributes } from 'react'
import { getInitials } from './avatarUtils'
import './avatar.css'

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export type AvatarProps = {
  photoURL?: string | null
  name?: string | null
  initials?: string | null
  size?: AvatarSize
  className?: string
  style?: CSSProperties
  alt?: string
  testId?: string
  onError?: () => void
  imgProps?: Partial<ImgHTMLAttributes<HTMLImageElement>>
}

export const Avatar = ({
  photoURL,
  name,
  initials,
  size,
  className,
  style,
  alt,
  testId,
  onError,
  imgProps,
}: AvatarProps) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null)
  const isImageFailed = Boolean(photoURL && failedUrl === photoURL)

  const computedInitials = initials ?? getInitials(name)
  const sizeClass = size ? `commonAvatar--${size}` : ''
  const combinedClass = ['commonAvatar', sizeClass, className].filter(Boolean).join(' ')

  const shouldRenderImage = Boolean(photoURL) && !isImageFailed

  return (
    <span className={combinedClass} style={style} data-testid={testId}>
      {shouldRenderImage ? (
        <img
          src={photoURL!}
          alt={alt ?? name ?? ''}
          referrerPolicy="no-referrer"
          onError={() => {
            if (photoURL) {
              setFailedUrl(photoURL)
            }
            onError?.()
          }}
          {...imgProps}
        />
      ) : (
        computedInitials
      )}
    </span>
  )
}
